import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { callLocationListGet, callLocationDelete } from '../../actions/locations'
import { Link, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

let CompanyList = ({ setPageAttr, list, methods: { callLocationListGet, callLocationDelete } }) => {
    let [searchParams] = useSearchParams();
    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callLocationDelete(id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callLocationListGet({}, pg)
                })
            }
        })
    }
    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'info',
            name: 'company',
            align: 'left',
            label: 'Empresa'
        },
        {
            type: 'info',
            name: 'region',
            align: 'left',
            label: 'Região'
        },
        {
            type: 'info',
            name: 'code',
            align: 'right',
            label: 'Código'
        },
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'info',
            name: 'category',
            align: 'left',
            label: 'Categoria'
        },
        {
            type: 'datetime',
            name: 'createdAt',
            align: 'right',
            label: 'Cadastro'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <Link to={'/locations/edit/' + a.id} className='btn btn-sm btn-primary'><i className='fas fa-edit'></i></Link>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callLocationListGet({}, pg)
    }, [callLocationListGet, searchParams])

    useEffect(() => {
        setPageAttr({
            title: 'Locais',
            caption: 'Gestão dos dados dos locais',
            btns: [
                {
                    type: 'link',
                    class: 'btn btn-primary',
                    icon: 'fas fa-plus',
                    label: 'Adicionar',
                    to: '/locations/add'
                }
            ],
            tabs: [
                {
                    active: true,
                    to: '/locations',
                    label: 'Informações'
                }
            ]
        })
    }, [setPageAttr])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/locations'} />
    )
}

const mapStateToProps = ({ register: { locations: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callLocationListGet,
            callLocationDelete
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyList)